import {NavLinksHelper} from "@/helpers/NavLinksHelper";
import {QUICK_COMMANDS, MIN_NAME_LENGTH, MAX_SUGGESTIONS} from "@/helpers/QuickMenuCommands";
import {allowedSettingsTabs} from "@/helpers/SettingsTabs";

export const QUICK_ACTIONS = [
    {
        id: "product.add",
        text: "productPage.addProduct",
        icon: "shopping-cart.svg",
        linkId: "ADMIN_GROUPS",
        route: "CatalogPage",
        module: "product",
        mutation: "setCurrentProduct",
        payload: {}
    },
    {
        id: "optionList.add",
        text: "productOptionsPage.addList",
        icon: "list.svg",
        linkId: "ADMIN_PRODUCT_OPTIONS",
        route: "ProductOptions",
        module: "productOption",
        mutation: "setIsAddingOptionList",
        payload: true
    },
    {
        id: "group.add",
        text: "productGroupPage.addGroup",
        icon: "package.svg",
        linkId: "ADMIN_GROUPS",
        route: "CatalogPage",
        module: "productGroup",
        mutation: "setIsAddingGroup",
        payload: true
    },
    {
        id: "user.add",
        text: "userPage.addUser",
        icon: "user.svg",
        linkId: "ADMIN_USERS",
        route: "UsersPage",
        module: "user",
        mutation: "setAddingUser",
        payload: true
    },
    {
        id: "table.add",
        text: "tablePage.addTable",
        icon: "table.svg",
        linkId: "ADMIN_TABLES",
        route: "TablesPage",
        module: "table",
        mutation: "setCurrentTable",
        payload: {}
    },
    {
        id: "zone.add",
        text: "tablePage.addTableZone",
        icon: "map-pin.svg",
        linkId: "ADMIN_TABLES",
        route: "TablesPage",
        module: "table",
        mutation: "setCurrentZone",
        payload: {}
    },
    {
        id: "printer.add",
        text: "printerStrings.addPrinter",
        icon: "printer.svg",
        linkId: "ADMIN_PRINTERS",
        route: "Printers",
        module: "printer",
        mutation: "setCurrentPrinter",
        payload: {}
    },
    {
        id: "promo.add",
        text: "promoPageStrings.addPromo",
        icon: "percent.svg",
        linkId: "ADMIN_PROMO_CODES",
        route: "Promo",
        module: "promo",
        mutation: "setIsAddingPromo",
        payload: true
    },
    {
        id: "voucher.add",
        text: "voucherPageStrings.createVouchers",
        icon: "gift.svg",
        linkId: "ADMIN_VOUCHERS",
        route: "Vouchers",
        module: "voucher",
        mutation: "setIsCreatingVouchers",
        payload: true
    },
    {
        id: "deliveryArea.add",
        text: "deliveryAreaPage.addDeliveryArea",
        icon: "mapw.svg",
        linkId: "ADMIN_DELIVERY_AREA",
        route: "DeliveryAreas",
        page: "/delivery-areas",
        module: "deliveryArea",
        mutation: "setIsAddingDeliveryArea",
        payload: true
    },
    {
        id: "pickup.add",
        text: "pickupPageStrings.addPickup",
        icon: "map-pin.svg",
        linkId: "ADMIN_PICKUP",
        route: "Pickup",
        module: "pickup",
        mutation: "setIsAddingPickup",
        payload: true
    },
    {
        id: "client.add",
        text: "clientStrings.addClient",
        icon: "users.svg",
        linkId: "ADMIN_CLIENT_DATA",
        route: "clients",
        module: "client",
        mutation: "setIsAddingClient",
        payload: true
    },
    {
        id: "integration.add",
        text: "integrationStrings.addInt",
        icon: "integration.svg",
        linkId: "ADMIN_INTEGRATION",
        route: "ExtIntegration",
        module: "integration",
        mutation: "setIsAddingIntegration",
        payload: true
    },
    {
        id: "kitchen.add",
        text: "kitchenPageStrings.addMessage",
        icon: "kitchen.svg",
        linkId: "ADMIN_KITCHEN",
        route: "Kitchen",
        module: "kitchen",
        mutation: "setIsAddingKitchen",
        payload: true
    },
    {
        id: "media.add",
        text: "imagePageStrings.addImage",
        icon: "picture.svg",
        linkId: "ACCOUNT_IMAGE",
        route: "Media",
        module: "images",
        mutation: "setIsAddingImage",
        payload: true
    },
    {
        id: "icon.add",
        text: "iconsPageStrings.addIcon",
        icon: "crop.svg",
        linkId: "ACCOUNT_ICONS",
        route: "Icons",
        module: "icons",
        mutation: "setIsAddingIcon",
        payload: true
    },
    {
        id: "org.add",
        text: "navBar.createOrg",
        icon: "plus-square.svg",
        linkId: "SUPER_USER_CREATE_ORG",
        route: "create-org",
        module: "organisation",
        mutation: "setIsCreatingOrg",
        payload: true
    },
    {
        id: "superUser.add",
        text: "superUserPage.addSuperUser",
        icon: "shield.svg",
        linkId: "SUPER_USER_CREATE_USER",
        route: "SuperUsersPage",
        module: "superUser",
        mutation: "setAddingSuperUser",
        payload: true
    }
];

const PAGE_KEYWORDS = {
    ANALYTICS_DASHBOARD_HANDLER: "dashboard tableau bord accueil home overzicht",
    ADMIN_GROUPS: "catalogue catalog carte kaart produit produits product products article item artikel groupe groupes group groups categorie category rayon groep",
    ADMIN_USERS: "utilisateur user employe staff gebruiker equipe",
    SU_MENU: "menu carte caisse kaart",
    ADMIN_PRODUCT_OPTIONS: "option liste list lijst supplement extra choix garniture optie keuze",
    ADMIN_TABLES: "table zone salle type tafel",
    ADMIN_KITCHEN: "cuisine kitchen keuken message",
    ADMIN_PROMO_CODES: "promo promotion promotions reduction discount korting code",
    ADMIN_VOUCHERS: "voucher bon achat cheque cadeau gift coupon waardebon",
    ADMIN_PICKUP: "pickup retrait point afhaal",
    ADMIN_DELIVERY_AREA: "livraison delivery zone secteur perimetre carte levering bezorging",
    ADMIN_PRINTERS: "imprimante printer ticket",
    ADMIN_CLIENT_DATA: "client customer klant",
    ADMIN_INVOICE: "facture invoice factuur",
    ADMIN_INTEGRATION: "integration api externe koppeling",
    ADMIN_DEVICES: "appareil device terminal caisse apparaat",
    ADMIN_PLAYLISTS: "menu digital screen ecran playlist tv scene",
    ANALYTICS_ACCOUNTS: "compte historique account history rekening",
    ANALYTICS_PAYMENTS: "paiement payment betaling caisse",
    ANALYTICS_ORDERS: "commande order bestelling historique produit",
    ANALYTICS_SHIFTS: "service shift dienst cloture caisse",
    ACCOUNT_IMAGE: "media image photo video afbeelding",
    ACCOUNT_ICONS: "icone icon picto allergene",
    ACCOUNTS_SETTINGS: "reglage parametre settings configuration instellingen",
    SUPER_USER_CREATE_ORG: "organisation org creer create nieuwe",
    SU_IMPORT_CSV: "import menu csv excel xlsx fichier file bestand",
    SUPER_USER_CREATE_USER: "super user su admin beheerder"
};

const ACTION_KEYWORDS = {
    "deliveryArea.add": "zone livraison delivery area secteur leveringszone",
    "product.add": "produit product article artikel",
    "group.add": "groupe group categorie rayon groep",
    "user.add": "utilisateur user employe gebruiker",
    "table.add": "table tafel salle",
    "zone.add": "zone table salle tafel",
    "printer.add": "imprimante printer ticket",
    "promo.add": "promo promotion reduction korting",
    "voucher.add": "voucher bon achat cadeau coupon waardebon",
    "pickup.add": "pickup retrait afhaal",
    "client.add": "client customer klant",
    "integration.add": "integration api externe",
    "kitchen.add": "cuisine kitchen keuken message",
    "media.add": "media image photo video upload afbeelding",
    "icon.add": "icone icon picto allergene",
    "superUser.add": "super user su admin beheerder",
    "org.add": "organisation org etablissement client nieuwe"
};

const HIDDEN_PAGES = ["SUPER_USER_CREATE_ORG"];

const ADD_KEYWORDS = "ajouter ajout creer nouveau add create new toevoegen nieuw";

function normalize(value) {
    return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}

function distance(a, b) {
    if (a === b) return 0;
    if (!a.length || !b.length) return Math.max(a.length, b.length);

    let previous = Array.from({length: b.length + 1}, (_, index) => index);

    for (let i = 1; i <= a.length; i += 1) {
        const current = [i];
        for (let j = 1; j <= b.length; j += 1) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            current[j] = Math.min(current[j - 1] + 1, previous[j] + 1, previous[j - 1] + cost);
        }
        previous = current;
    }

    return previous[b.length];
}

function tolerance(word) {
    if (word.length <= 3) return 0;
    if (word.length <= 5) return 1;
    if (word.length <= 8) return 2;
    return 3;
}

function isSubsequence(word, token) {
    let index = 0;
    for (const letter of token) {
        if (letter === word[index]) index += 1;
        if (index === word.length) return true;
    }
    return word.length === index;
}

function scoreWord(word, tokens) {
    let best = 0;

    for (const token of tokens) {
        if (token === word) return 100;
        if (token.startsWith(word)) best = Math.max(best, 80);
        else if (token.includes(word)) best = Math.max(best, 60);
        else if (distance(word, token) <= tolerance(word)) best = Math.max(best, 40);
        else if (word.length >= 4 && isSubsequence(word, token)) best = Math.max(best, 20);
    }

    return best;
}

export class QuickMenuHelper {

    static pages(user, isPhone, translate) {
        return NavLinksHelper.allowedLinks(user, isPhone)
            .filter((link) => !HIDDEN_PAGES.includes(link.id))
            .flatMap((link) => {
                const base = {
                    text: link.text,
                    icon: link.icon,
                    linkId: link.id,
                    keywords: PAGE_KEYWORDS[link.id] || ""
                };

                if (link.quickViews?.length) {
                    return link.quickViews.map((view) => ({
                        ...base,
                        id: `page:${link.id}:${view.subtitle}`,
                        label: `${translate(link.text)} — ${translate(view.subtitle)}`,
                        page: view.page,
                        commandId: view.commandId
                    }));
                }

                return [{
                    ...base,
                    id: `page:${link.id}`,
                    label: link.subtitle ? `${translate(link.text)} — ${translate(link.subtitle)}` : null,
                    page: link.page
                }];
            });
    }

    static canUseSettings(user, isPhone) {
        return NavLinksHelper.allowedLinks(user, isPhone).some((link) => link.id === "ACCOUNTS_SETTINGS");
    }

    static settingsTabs(user, isPhone, translate) {
        if (!QuickMenuHelper.canUseSettings(user, isPhone)) return [];

        const settings = translate("navBar.settings");

        return allowedSettingsTabs(user, isPhone).map((tab) => ({
            id: `settingsTab:${tab.index}`,
            label: `${settings} — ${tab.title.includes(".") ? translate(tab.title) : tab.title}`,
            icon: tab.icon,
            page: `/settings/${tab.index}`,
            keywords: `${settings} settings parametres reglages ${tab.keywords}`
        }));
    }

    static actions(user, isPhone) {
        const allowed = new Set(NavLinksHelper.allowedLinks(user, isPhone).map((link) => link.id));
        return QUICK_ACTIONS
            .filter((action) => allowed.has(action.linkId))
            .map((action) => ({
                ...action,
                keywords: `${ACTION_KEYWORDS[action.id] || ""} ${ADD_KEYWORDS}`
            }));
    }

    static scoreAgainst(text, search) {
        const words = normalize(search).split(/\s+/).filter(Boolean);
        if (!words.length) return 1;

        const tokens = normalize(text).split(/[^a-z0-9]+/).filter(Boolean);
        let total = 0;

        for (const word of words) {
            const score = scoreWord(word, tokens);
            if (!score) return 0;
            total += score;
        }

        return total / words.length;
    }

    static parseQuery(search) {
        const match = String(search || "").match(/^([^:=#]*)[:=#]\s*(.*)$/);
        if (!match) return null;

        const word = match[1].trim();
        if (!word) return null;

        return {word, rest: match[2].trim()};
    }

    static commands(user, isPhone) {
        const allowed = new Set(NavLinksHelper.allowedLinks(user, isPhone).map((link) => link.id));

        return QUICK_COMMANDS.filter((command) => {
            if (command.linkId) return allowed.has(command.linkId);
            if (command.switchOrg) return (user?.managedOrganizations || []).length > 1;
            return true;
        });
    }

    static commandEntries(user, isPhone) {
        return QuickMenuHelper.commands(user, isPhone).map((command) => ({
            id: `command:${command.id}`,
            text: command.text,
            icon: command.icon,
            keywords: command.keywords,
            commandKeyword: command.keyword
        }));
    }

    static commandPage(command, user, isPhone) {
        if (!command?.linkId) return "";
        const link = NavLinksHelper.allowedLinks(user, isPhone).find((row) => row.id === command.linkId);
        if (!link) return "";
        return command.page || link.page || "";
    }

    static parseCommand(search, user, isPhone) {
        const parsed = QuickMenuHelper.parseQuery(search);
        if (!parsed) return null;

        const command = QuickMenuHelper.commands(user, isPhone)
            .map((entry) => ({entry, score: QuickMenuHelper.scoreAgainst(`${entry.keyword} ${entry.keywords}`, parsed.word)}))
            .filter((row) => row.score > 0)
            .sort((a, b) => b.score - a.score)
            .map((row) => row.entry)[0];

        return command ? {command, argument: parsed.rest} : null;
    }

    static parseOrgId(search, user, isPhone) {
        const term = String(search || "").trim();
        if (!/^\d+$/.test(term)) return null;

        const command = QuickMenuHelper.commands(user, isPhone).find((entry) => entry.switchOrg);
        return command ? {command, argument: term} : null;
    }

    static suggestions(command, argument, rows, user) {
        const term = String(argument || "").trim();
        const isId = /^\d+$/.test(term);

        if (command.freeText) {
            return term.length ? [{id: term, label: term, entityId: term}] : [];
        }

        if (command.idOnly) {
            return isId ? [{id: term, label: term, entityId: term}] : [];
        }

        const source = command.source;
        const list = source.user ? (user?.[source.user] || []) : (rows || []);
        const currentOrgId = command.switchOrg ? String(user?.orgId) : null;

        const minLength = command.minLength || MIN_NAME_LENGTH;
        if (term.length < (isId ? 1 : minLength)) return [];

        const idScore = (value) => {
            if (value === term) return 100;
            if (!command.idPartial) return 0;
            if (value.startsWith(term)) return 80;
            return value.includes(term) ? 60 : 0;
        };

        return list
            .filter((item) => !currentOrgId || String(item[source.idKey]) !== currentOrgId)
            .map((item) => ({
                item,
                score: isId
                    ? idScore(String(item[source.idKey]))
                    : QuickMenuHelper.scoreAgainst(String(item[source.labelKey] || ""), term)
            }))
            .filter((row) => row.score > 0)
            .sort((a, b) => b.score - a.score || String(a.item[source.labelKey] || "").localeCompare(String(b.item[source.labelKey] || "")))
            .slice(0, MAX_SUGGESTIONS)
            .map((row) => ({
                id: String(row.item[source.idKey]),
                label: String(row.item[source.labelKey] || row.item[source.idKey]),
                entityId: row.item[source.idKey]
            }));
    }

    static rank(label, keywords, search) {
        const onLabel = QuickMenuHelper.scoreAgainst(label, search);
        const onAll = QuickMenuHelper.scoreAgainst(`${label} ${keywords || ""}`, search);
        return {score: Math.max(onLabel, onAll), direct: onLabel > 0};
    }
}
